var quiz = {
    title: 'Drikkevaner',
    questions: [
      {
        text: "Har det skjedd det siste året at du ikke har klart å slutte å drikke når du først har begynt?",
        subtext: " Har du for eksempel gått ut for å ta en øl, men ikke gått hjem før baren stengte?",
        resultNotTitle: 'Du klarer å slutte når du først har begynt å drikke.',
        resultNot: `Å ikke kunne slutte å drikke når man først har begynt, er en av utfordringene som knyttes til avhengighet. Derfor har vi stilt dette spørsmålet.
        Du har svart nei, og det viser at du kan slutte når du vil, og at alkoholen ikke styrer avgjørelsene dine.`,
        resultTitle:'Du har ikke klart å slutte når du først har begynt å drikke.',
        result: `
        Å ikke kunne slutte å drikke når man først har begynt, er en av utfordringene som knyttes til avhengighet. Derfor har vi stilt dette spørsmålet.
        Å miste kontroll over drikkingen handler ikke om hvor ofte man drikker, men handler om at man mister kontroll over mengden, og at man prioriterer drikking over annet, til tross for alvorlige konsekvenser av drikkingen. `,
        responses: [
          {text: 'Daglig eller nesten hver dag', value: 4, points: 4},
          {text: 'Hver uke', value: 3, points: 3},
          {text: 'Hver måned', value: 2, points: 2},
          {text: 'Sjeldnere enn en gang i måneden', value: 1, points: 1},
          {text: 'Aldri', value: 0, points: 0 },
        ]
      }, {
        text: "Hvor ofte det siste året har du latt være å gjøre noe du burde ha gjort, fordi du har drukket?",
        subtext: "Har du for eksempel valgt bort eller gått glipp av noe fordi du var beruset, eller valgt bort eller gått glipp av noe dagen derpå?",
        resultNotTitle: 'Du lar ikke være å gjøre noe du burde ha gjort, fordi du har drukket.',
        resultNot: `Du hopper ikke over ting fordi du har drukket. Da er det ikke alkoholen som kontrollerer livet ditt, men du selv.
        At det er viktigere å drikke enn å gjøre det man har planlagt, kan være et tegn på avhengighet. Derfor har vi stilt dette spørsmålet.`,
        resultTitle:'Du har latt være å gjøre noe du burde ha gjort, fordi du har drukket.',
        result: `
        Et jobbmøte, en familiemiddag eller en treningsøkt – én eller flere ganger har du droppet noe du har planlagt, på grunn av alkohol.
At det er viktigere å drikke alkohol enn å gjøre det du har planlagt, kan være et tegn på avhengighet. Derfor har vi stilt dette spørsmålet.`,
        responses: [
          {text: 'Daglig eller nesten hver dag', value: 4, points: 4},
          {text: 'Hver uke', value: 3, points: 3},
          {text: 'Hver måned', value: 2, points: 2},
          {text: 'Sjeldnere enn en gang i måneden', value: 1, points: 1},
          {text: 'Aldri', value: 0, points: 0 },
        ]
      },
      {
        text: "Har du noen gang drukket alkohol dagen derpå for å føle deg bedre?",
        subtext: "Ta utgangspunkt i det siste året.",
        resultNotTitle: 'Du drikker ikke alkohol dagen derpå for å komme til hektene.',
        resultNot: `Å drikke for å lindre bakrusen kan bli begynnelsen på en ond sirkel og kan være et tegn på avhengighet. Derfor har vi stilt dette spørsmålet.
        Du drikker ikke dagen derpå og havner derfor ikke i en ond sirkel. Det er bra!`,
        resultTitle:'Du har drukket alkohol dagen derpå for å komme til hektene.',
        result: `
        Å drikke dagen derpå kan lindre bakrusen, men fører også til at du drikker igjen – og blir i bakrus igjen. Hvis du begynner å reparere med et glass eller to, kan du fort komme inn i en ond sirkel.
Å prøve å lindre bakrusen med å reparere kan være et tegn på avhengighet. Derfor har vi stilt dette spørsmålet.`,
        responses: [
          {text: 'Daglig eller nesten hver dag', value: 4, points: 4},
          {text: 'Hver uke', value: 3, points: 3},
          {text: 'Hver måned', value: 2, points: 2},
          {text: 'Sjeldnere enn en gang i måneden', value: 1, points: 1},
          {text: 'Aldri', value: 0, points: 0 },
        ]
      }, {
        text: "Har du hatt dårlig samvittighet eller skyldfølelse på grunn av drikkingen?",
        subtext: "I så fall, hvor ofte det siste året?",
        resultNotTitle: 'Du har ikke hatt dårlig samvittighet eller skyldfølelse på grunn av drikkingen.',
        resultNot: `Du har ikke hatt dårlig samvittighet eller skyldfølelse på grunn av at du har drukket alkohol. Da drikker du trolig ikke på en måte som påvirker deg selv eller andre negativt.`,
        resultTitle:'Du har hatt dårlig samvittighet eller skyldfølelse på grunn av drikkingen.',
        result: `
        Alkohol gjør deg opprømt og avslappet, og du blir kvitt hemningene. Det kan føles lettere å snakke med andre, og du får bedre selvtillit.
Men når hemningene forsvinner, kan du fort komme til å gjøre ting du angrer på. Plutselig har du sagt eller gjort noe som skader andre.
Den dårlige samvittigheten og skyldfølelsen er en konsekvens av drikkingen.`,
        responses: [
          {text: 'Daglig eller nesten hver dag', value: 4, points: 4},
          {text: 'Hver uke', value: 3, points: 3},
          {text: 'Hver måned', value: 2, points: 2},
          {text: 'Sjeldnere enn en gang i måneden', value: 1, points: 1},
          {text: 'Aldri', value: 0, points: 0 },
        ]
      },
      {
        text: "Har du hatt blackout det siste året, altså drukket så mye alkohol at du dagen etter ikke husker ting du har sagt eller gjort?",
        resultNotTitle: 'Du har ikke hatt blackout det siste året.',
        resultNot: `Det å få en hjerneskade på grunn av drikking – som en blackout faktisk innebærer – er en alvorlig konsekvens. Det er bra at du ikke drikker så mye at du får blackout!`,
        resultTitle:'Du har hatt en blackout det siste året.',
        result: `
        Når du drikker så mye at du får blackout, skader du hjernen.
Alkoholen svekker hukommelsen og gjør det vanskeligere å huske hva som har skjedd.
Blackout er en alvorlig konsekvens av drikkingen, både på kort og lang sikt.`,
        responses: [
          {text: 'Daglig eller nesten hver dag', value: 4, points: 4},
          {text: 'Hver uke', value: 3, points: 3},
          {text: 'Hver måned', value: 2, points: 2},
          {text: 'Sjeldnere enn en gang i måneden', value: 1, points: 1},
          {text: 'Aldri', value: 0, points: 0 },
        ]
      }, {
        text: "Har drikkingen skapt problemer for deg selv eller andre?",
        subtext: "For eksempel ved at du har havnet i trøbbel, kommet ut for en ulykke eller gjort noen lei seg",
        resultNotTitle: 'Du drikker ikke så mye at det skaper trøbbel for deg selv eller andre.',
        resultNot: `Du drikker ikke så mye at det skaper trøbbel for deg selv eller andre. Det er bra!
        Med alkoholen forsvinner hemningene, og vurderingsevnen svekkes. Plutselig har man sagt eller gjort noe som sårer en annen. Det slipper du.`,
        resultTitle:'Du eller noen andre har fått problemer fordi du har drukket.',
        result: `
        Alkoholbruk kan ha negative konsekvenser både for deg selv og andre. Det har du opplevd.
Drikkingen svekker vurderingsevnen. Plutselig har du sagt eller gjort noe som skader andre.
I rundt en tredjedel av alle ulykker med dødelig utfall er alkohol en medvirkende årsak.
Alkohol påvirker også den psykiske helsen din. Du kan få angst, bli mer påvirket av stress og sove dårligere.`,
        responses: [
          {text: 'Ja, det siste året', value: 4, points: 4}, 
          {text: 'Ja, men ikke det siste året', value: 2, points: 2}, 
          {text: 'Nei', value: 0, points: 0}, 
        ]
      },
      {
        text: "Har noen vært bekymret over hvor mye du drikker, eller antydet at du burde drikke mindre?",
        subtext:"Spydige bemerkninger gjelder også.",
        resultNotTitle: 'Ingen har vært bekymret for deg eller antydet at du burde drikke mindre.',
        resultNot: `Det er bra at ingen er bekymret for drikkingen din!
        At noen andre er bekymret, er et faresignal, og det var derfor du fikk spørsmålet.`,
        resultTitle:'Noen har vært bekymret eller antydet at du burde drikke mindre.',
        result: `
        En av de vanligste grunnene til at man endrer alkoholvanene sine, er nettopp det at noen har uttrykt bekymring.
At drikkingen har fått konsekvenser ikke bare for deg selv, men også for noen som bryr seg om deg, kan være akkurat den dytten du trenger.
At noen har uttrykt bekymring over drikkingen din, er et faresignal. Lytt til den som bryr seg. Ofte er det en grunn til at de er bekymret.`,
        responses: [
          {text: 'Ja, det siste året', value: 4, points: 4}, 
          {text: 'Ja, men ikke det siste året', value: 2, points: 2}, 
          {text: 'Nei', value: 0, points: 0}, 
        ]
      }, {
        text: "Har noen av foreldrene eller besteforeldrene dine hatt alkoholproblemer?",
        resultNotTitle: '',
        resultNot: ``,
        resultTitle:'Du har en forelder eller besteforelder med alkoholproblemer.',
        result: `
        Studier har vist at du som har en forelder eller besteforelder med alkoholproblemer, har mellom fire og åtte ganger høyere risiko for å utvikle avhengighet enn dem som ikke har noen arvelige anlegg.
At noen i familien din har alkoholproblemer, betyr ikke nødvendigvis at du også kommer til å få det, men risikoen er større. Du kan med fordel være forsiktig med hvor mye du drikker.`,
        responses: [
          {text: 'Ja', value: 4, points: 0}, 
          {text: 'Vet ikke', value: 2, points: 0}, 
          {text: 'Nei', value: 0, points: 0}, 
        ]
      }                   
    ]
};
  
export default quiz;